import { createSlice } from "@reduxjs/toolkit";

const taskMetaSlice=createSlice({
    name:'taskMeta',
    initialState:{
        pinnedCount:0,
    },
    reducers:{
        setPinnedCount:(state, action)=>{
            state.pinnedCount=Number(action.payload || 0);
        },
    }
})

export const {setPinnedCount}=taskMetaSlice.actions
export default taskMetaSlice.reducer;
